import { useEffect } from "react";

export const useModal = (
  isVisible: boolean,
  onClose: () => void,
  options?: { closeOnBackdrop?: boolean; closeOnEsc?: boolean },
) => {
  const { closeOnBackdrop = true, closeOnEsc = true } = options ?? {};

  useEffect(() => {
    if (!isVisible) return;

    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape" && closeOnEsc) onClose();
    };

    document.addEventListener("keydown", handleEsc);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "";
    };
  }, [isVisible, closeOnEsc, onClose]);

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (!closeOnBackdrop) return;
    if (e.target === e.currentTarget) onClose();
  };

  return { handleBackdropClick };
};
